import { Context, useContext } from 'react';

// Re-use `.mjs` context — calling createContext creates a separate one the
// .mjs Provider never populates. See AuthContextV1.tsx for the same pattern.
import { context as mjsCityContext } from './CityContext.mjs';

export interface CityContextType {
  city_selected: string | undefined;
  selected_city_label: string | undefined;
  set_city_selected: (
    citySelected: string | undefined,
    cityLabel: string | undefined,
  ) => void;
  category: string;
  query_params: string;
}

const context = mjsCityContext as Context<CityContextType>;

export function useCitySelectedContext(): CityContextType {
  return useContext(context);
}

export { context as CityContextRaw };
